import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/CustomButton/CustomButton';
import { Row, Col } from 'react-bootstrap';
import Upload from '../../../lib/upload';
import axios from 'axios/index';
import { toast } from 'react-toastify';

class lodgingQuotationAddHotel extends Component {
  constructor(props) {
    super(props);

    this.messageIniciando = {};
    this.messageAccediendo = {};
    this.messageCapturando = {};
    this.messageEstructurando = {};
    this.messageFinalizando = {};
  }

  componentWillMount() {}

  componentDidMount() {
    this.props.onRef(this);
    this.props.onChange([], {
      ...this.props.formData,
      create: true,
    });
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  cancelGetHotel = () => {
    clearTimeout(this.messageAccediendo);
    clearTimeout(this.messageCapturando);
    clearTimeout(this.messageEstructurando);
    clearTimeout(this.messageFinalizando);
    this.props.onGettingHotel(false, '', false);
  };

  getHotelInformation = () => {
    var _this = this;
    this.props.onGettingHotel(true, 'Iniciando...');

    this.messageAccediendo = setTimeout(function () {
      _this.props.onGettingHotel(true, 'Accediendo a página...');
    }, 1000);

    this.messageCapturando = setTimeout(function () {
      _this.props.onGettingHotel(true, 'Capturando imágenes...');
    }, 3000);

    this.messageEstructurando = setTimeout(function () {
      _this.props.onGettingHotel(true, 'Estructurando datos...');
    }, 4000);

    this.messageFinalizando = setTimeout(function () {
      _this.props.onGettingHotel(true, 'Finalizando...');
    }, 5000);

    axios
      .get(
        process.env.REACT_APP_URL_API_HOTELS +
          '/hotels/?url=' +
          this.props.formData.urlSource
      )
      .then((res) => {
        try {
          const hotelsJson = res.data;
          var imageArray = [];
          hotelsJson.images.slice(0, 10).map(function (image) {
            imageArray.push({
              name: image,
              comments: '',
              progress: 0,
              source: 'web',
              selected: true,
            });
          });
          _this.props.onChange([], {
            ..._this.props.formData,
            images: [],
            name: hotelsJson.name,
            address: hotelsJson.address,
            description: hotelsJson.tagline,
            imagesWeb: imageArray,
            create: true,
          });
          _this.cancelGetHotel();
        } catch (error) {
          console.error(error.message);
          toast.error('Verifica que el link sea de hoteles.com');
        }
      });
  };

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <h4 style={{ margin: '10px 0px 10px 0px' }}>Crear Hotel</h4>
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <div className="form-group">
              <label htmlFor="buyprice" style={{ fontWeight: '400' }}>
                <strong>URL HOTEL (bestday.com)</strong>
              </label>
              <input
                style={{ backgroundColor: '#f3f3f3' }}
                type="text"
                className="form-control"
                id="buyprice"
                value={this.props.formData.urlSource}
                onChange={(event) =>
                  this.props.onChange(['urlSource'], event.target.value)
                }
              />
            </div>{' '}
          </Col>
          <Col md={4} style={{ textAlign: 'right' }}>
            <Button
              fill
              onClick={this.getHotelInformation}
              style={{ marginTop: 25 }}
            >
              {' '}
              <i className="fa fa-download" /> Conseguir información
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="form-group">
              <label htmlFor="buyprice" style={{ fontWeight: '400' }}>
                <strong>NOMBRE</strong>
              </label>
              <input
                type="text"
                required={true}
                className="form-control"
                id="buyprice"
                value={this.props.formData.name}
                onChange={(event) =>
                  this.props.onChange(['name'], event.target.value)
                }
              />
            </div>{' '}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="form-group">
              <label htmlFor="buyprice" style={{ fontWeight: '400' }}>
                <strong>DIRECCIÓN</strong>
              </label>
              <input
                type="text"
                className="form-control"
                id="buyprice"
                value={this.props.formData.address}
                onChange={(event) =>
                  this.props.onChange(['address'], event.target.value)
                }
              />
            </div>{' '}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="form-group">
              <label htmlFor="buyprice" style={{ fontWeight: '400' }}>
                <strong>DESCRIPCIÓN</strong>
              </label>
              <textarea
                className={'form-control'}
                value={this.props.formData.description}
                onChange={(event) =>
                  this.props.onChange(['description'], event.target.value)
                }
              />
            </div>{' '}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="form-group">
              <label htmlFor="buyprice" style={{ fontWeight: '400' }}>
                <strong>FOTOS</strong>
              </label>
              <Row>
                {this.props.formData.imagesWeb.map((image, index) => (
                  <Col md={4} key={index} style={{ marginBottom: 20 }}>
                    <img src={image.name} width={'100%'} alt="" />
                    {/*<input type="checkbox" value={true} onChange={value => this.props.onChange(['imagesWeb', index, "selected"], !image.selected)} /> <label>Seleccionar</label>*/}
                  </Col>
                ))}
              </Row>
              <Row>
                <Col md={12} style={{ marginTop: 30 }}>
                  <Upload
                    label="Imágenes del hotel y cuartos"
                    files={this.props.formData.images}
                    onChange={(file) => this.props.onChange(['images'], file)}
                    multiple={true}
                  />
                </Col>
              </Row>
            </div>{' '}
          </Col>
        </Row>
        <hr />
      </div>
    );
  }
}

export default connect((state) => ({ Quotations: state.Quotations }))(
  lodgingQuotationAddHotel
);



// WEBPACK FOOTER //
// ./src/views/Quotations/cards/lodgingQuotationAddHotel.js